(function (factory) {

	if (typeof define === "function" && define.amd)
		define('bootstrap.collapse.toggleblocker',["jquery", "bootstrap"], factory);
	else
		factory(jQuery);

}(function ($) {
	"use strict";

	$(".collapse.collapse-disable-toggle").on("show.bs.collapse", function (e) {
		$.data(document.body, "bs.collapse.showing", true);
	});

	$(".collapse.collapse-disable-toggle").on("hide.bs.collapse", function (e) {
		if (!$.data(document.body, "bs.collapse.showing")) {
			e.preventDefault();
			$("a[href = '#" + $(e.target).attr("id") + "']").removeClass("collapsed");
		}

		$.data(document.body, "bs.collapse.showing", false);
	});

}));
